/* AQ — Rails à flèches, moteur, v1.3, 2026-09-18.

   Décision de Félix, patron relevé sur materialbank.com : une rangée qui
   défile porte une flèche à chaque bout, et la flèche ne paraît que du côté
   où il reste du chemin.

   Le moteur est générique. Il prend une rangée déjà défilante, l'enveloppe
   dans un conteneur de position, pose les deux boutons, et tient leur état à
   jour au défilement, au redimensionnement et quand le contenu de la rangée
   change. Il ne touche ni au balisage de la rangée ni à ses propres
   comportements, donc l'espion d'onglets de la barre de fiche et le moteur de
   filtres continuent de fonctionner tels quels.

   Rangées servies : la table des matières d'une fiche (.aq-fnav) et la rangée
   de filtres des collections (.aqcn7__left).

   Le pas de défilement est de quatre cinquièmes de la largeur visible, jamais
   moins de 160 px : on garde toujours une pastille de l'écran précédent en
   vue, ce qui évite de perdre le fil. */
(function () {
  'use strict';

  var RANGEES = ['.aq-fnav', '.aqcn7__left'];
  var MARGE = 2; /* tolérance de sous-pixel */

  function chevron(vers) {
    var d = vers === 'av' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
  }

  function bouton(vers) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'aq-rail__go aq-rail__go--' + vers;
    b.setAttribute('aria-label', vers === 'av' ? 'Faire défiler vers la gauche' : 'Faire défiler vers la droite');
    b.innerHTML = chevron(vers);
    return b;
  }

  /* v1.2, 2026-09-16, décision de Félix : le mot « Filtre », qui ouvre le
     panneau latéral, est fixe. Il sortait du champ avec les facettes puisqu'il
     était la première pastille de la rangée qui défile. On le sort de la
     rangée et on le pose juste avant elle, dans la barre : plus rien ne le
     déplace, et les deux bouts de la rangée restent aux flèches. Le bouton
     lui-même est déplacé, pas recopié : il garde le comportement du thème. */
  function sortirFiltre(cadre, rangee) {
    var filtre = rangee.querySelector(':scope > .aqcn7__filtre--d');
    if (!filtre || !cadre.parentNode) return;
    cadre.parentNode.insertBefore(filtre, cadre);
  }

  function poserEtat(cadre, rangee) {
    var reste = rangee.scrollWidth - rangee.clientWidth;
    var x = rangee.scrollLeft;
    cadre.classList.toggle('is-avant', reste > MARGE && x > MARGE);
    cadre.classList.toggle('is-apres', reste > MARGE && x < reste - MARGE);
  }

  function pas(rangee) {
    return Math.max(160, Math.round(rangee.clientWidth * 0.8));
  }

  function equiper(rangee) {
    if (!rangee || rangee.parentNode.classList.contains('aq-rail')) return;

    var cadre = document.createElement('div');
    cadre.className = 'aq-rail';
    rangee.parentNode.insertBefore(cadre, rangee);
    /* v1.1 : la configuration de la barre de fiche est un frère de la rangée,
       et son moteur la cherche à ce titre. Si on enveloppe la rangée seule,
       le moteur ne trouve plus rien et la table des matières reste vide,
       relevé en direct le 2026-09-14. Le frère de configuration entre donc
       dans l'enveloppe avec la rangée. */
    var conf = cadre.parentNode.querySelector(':scope > [data-aq-fnav-config]');
    cadre.appendChild(rangee);
    if (conf) cadre.appendChild(conf);

    sortirFiltre(cadre, rangee);

    var av = bouton('av');
    var ap = bouton('ap');
    cadre.appendChild(av);
    cadre.appendChild(ap);

    av.addEventListener('click', function () { rangee.scrollBy({ left: -pas(rangee), behavior: 'smooth' }); });
    ap.addEventListener('click', function () { rangee.scrollBy({ left: pas(rangee), behavior: 'smooth' }); });

    var minuteur = null;
    function relever() {
      if (minuteur) return;
      minuteur = requestAnimationFrame(function () { minuteur = null; poserEtat(cadre, rangee); });
    }
    rangee.addEventListener('scroll', relever, { passive: true });
    window.addEventListener('resize', relever);
    if (window.ResizeObserver) { new ResizeObserver(relever).observe(rangee); }
    if (window.MutationObserver) {
      new MutationObserver(function () {
        /* la rangée est refaite à chaque changement de filtre : le bouton
           « Filtre » y revient avec le nouveau balisage, on le ressort. */
        sortirFiltre(cadre, rangee);
        relever();
      }).observe(rangee, { childList: true, subtree: true });
    }
    poserEtat(cadre, rangee);
  }

  function poser() {
    for (var i = 0; i < RANGEES.length; i++) {
      var l = document.querySelectorAll(RANGEES[i]);
      for (var j = 0; j < l.length; j++) equiper(l[j]);
    }
  }

  /* v1.1 : l'enveloppe est posée SEULEMENT une fois la page chargée. Les
     moteurs des rangées, celui de la table des matières et celui des filtres,
     s'exécutent avant et gardent ainsi le voisinage qu'ils attendent. Les
     flèches sont un ajout de confort, rien ne dépend d'elles pour que la
     rangée serve. */
  if (document.readyState === 'complete') {
    poser();
  } else {
    window.addEventListener('load', poser);
  }
  document.addEventListener('shopify:section:load', poser);
  /* v1.3, 2026-09-18 : la barre de filtres est refaite à chaque changement
     de filtre (échange de section) ; le rail se repose sur la rangée neuve. */
  document.addEventListener('aq:cn7:swap', poser);
})();
